import * as React from 'react';
const SvgRanking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.792 3.875a.5.5 0 0 0-.5.5v11.25a.5.5 0 0 0 .5.5h.417a.5.5 0 0 0 .5-.5V4.375a.5.5 0 0 0-.5-.5zm-2 .5a2 2 0 0 1 2-2h.417a2 2 0 0 1 2 2v11.25a2 2 0 0 1-2 2h-.417a2 2 0 0 1-2-2zm-3 3.667a.5.5 0 0 0-.5.5v7.083a.5.5 0 0 0 .5.5h.417a.5.5 0 0 0 .5-.5V8.542a.5.5 0 0 0-.5-.5zm-2 .5a2 2 0 0 1 2-2h.417a2 2 0 0 1 2 2v7.083a2 2 0 0 1-2 2h-.417a2 2 0 0 1-2-2zm-3 3.666a.5.5 0 0 0-.5.5v2.917a.5.5 0 0 0 .5.5h.417a.5.5 0 0 0 .5-.5v-2.917a.5.5 0 0 0-.5-.5zm-2 .5a2 2 0 0 1 2-2h.417a2 2 0 0 1 2 2v2.917a2 2 0 0 1-2 2h-.417a2 2 0 0 1-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRanking;
